import { Modal, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";

export default function Loading({
  title = "Please wait!",
  subTitle = "This won’t take long, we promise!",
  message = "We’re getting things ready for you. Thanks for your patience.",
  buttonTitle = "",
  onClickButton,
}) {
  const [timeLeft, setTimeLeft] = useState(10);

  useEffect(() => {
    if (timeLeft > 0) {
      setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
    }
  }, [timeLeft]);

  return (
    <Modal open>
      <div className="flex items-center justify-center min-h-[100vh]">
        <Paper className="p-6 shadow-lg w-[500px]" sx={{ borderRadius: 5 }}>
          <div className="flex flex-col items-center justify-center">
            {/* Enhanced multi-layer circle animation */}
            <div className="relative w-32 h-32">
              {/* Middle circle with rotating segments */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-28 h-28 border-4 border-dashed border-gray-400 rounded-full animate-rotate-slow"></div>
              </div>

              {/* Inner circle with pulsing icon and text */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center flex justify-center items-center flex-col">
                  <svg
                    className="w-8 h-8 text-primary animate-pulse"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 8v4l3 3m-9 5h12a2 2 0 002-2V7a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                  <p className="mt-2 text-sm text-gray-600">Processing...</p>
                </div>
              </div>
            </div>

            {/* Loading Text */}
            <div className="mt-4 text-center">
              <h2 className="text-3xl font-semibold text-gray-800">{title}</h2>
              <p className="mt-6 text-gray-600">{message}</p>
            </div>

            <div className="my-4">
              {buttonTitle && (
                <button
                  className="bg-primary text-white w-20 py-1 rounded hover:bg-primaryDark duration-500 disabled:bg-gray-500 disabled:cursor-not-allowed"
                  disabled={timeLeft > 0}
                  onClick={onClickButton}
                >
                  {timeLeft > 0 ? timeLeft : buttonTitle}
                </button>
              )}
            </div>

            {/* Subtle footer text */}
            <div className="text-sm text-gray-500">
              <p className="text-gray-400">{subTitle}</p>
            </div>
          </div>
        </Paper>
      </div>
    </Modal>
  );
}
